<template>
  <li>
    <el-card class="box-card">
      <div class="history-header-wrapper">
        <div class="header">
          <div style="display: -webkit-box;">
            <p class="title" align=left>{{title}}</p>
            <el-tooltip class="item" effect="light" placement="top-start">
              <div slot="content">Confirming your message<br/>may take 1 minute</div>
              <div style="padding-left: 8px" v-if="status">
                <loader-icon class="spinner" width=16 height=16></loader-icon>
              </div>
            </el-tooltip>
          </div>
          <p class="time" align=left>{{time}}</p>
        </div>
        <el-rate 
          v-if="score"
          v-model="score"
          disabled>
        </el-rate>
      </div>
      <div class="content">
        <div>{{message}}</div>
      </div>
    </el-card>
  </li>
</template>

<script>
import { LoaderIcon } from 'vue-feather-icons';

export default {
  props: ['title', 'message', 'score', 'time', 'status'],
  computed: {
  },
  methods: {
  },
  components: {
    LoaderIcon,
  },
};
</script>

<style>
  .box-card {
    max-width: 720px;
    width: 100%;
    margin: auto; 
    margin-bottom: 16px;
  }

  .box-card .history-header-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .box-card .history-header-wrapper .title {
    color: #48acf2;
  }

  .box-card .content {
    padding-top: 8px;
  }

  /* rotating */
  @-webkit-keyframes spinner /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes spinner {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  .spinner {
    -webkit-animation: rotating 2s linear infinite;
    -moz-animation: rotating 2s linear infinite;
    -ms-animation: rotating 2s linear infinite;
    -o-animation: rotating 2s linear infinite;
    animation: rotating 2s linear infinite;
    color: #48acf2;
  }

</style>

<style scoped>
  .el-tooltip {
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
  }

  .title, .time {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// HistoryItem.vue?3985cd2b